<template>
  <div class="register" data-aos="zoom-in">
    <h1 class="log">Sign up</h1>
    <p class="text">
      Go to your account to get a discount card and to track parcels.
    </p>
    <base-google @click="signInWithGoogle"></base-google>
    <p class="other-way">or sign up with Email</p>
    <input type="text" placeholder="Full name" v-model="fullName" />
    <input type="email" placeholder="Email" v-model="email" />
    <p v-if="!emailIsValid" class="error">{{ emailErrorMessage }}</p>
    <div class="password-wrapper">
      <input
        :type="passwordIsVisible ? 'text' : 'password'"
        placeholder="Password"
        v-model="password"
        class="password"
      />
      <button class="visibility-btn" @click="togglePasswordVisibility">
        <img v-if="!passwordIsVisible" src="/images/closeEye.svg" alt="" />
        <img v-else src="/images/openeye.svg" alt="" />
      </button>
    </div>
    <p v-if="!passwordIsValid" class="error">
      {{ passwordErrorMessage }}
    </p>
    <base-button @click="handleClick">Sign up</base-button>
    <p class="create-acc">
      Already have an account?
      <button @click="switchToRegister" class="dynamic-comp">Log in</button>
    </p>
  </div>
</template>
  
<script>
import validation from "./helper/validation.js";
import { computed } from "vue";
export default {
  data() {
    return {
      fullName: "",
      email: "",
      password: "",
      emailErrorMessage: "",
      passwordErrorMessage: "",
      emailIsValid: true,
      passwordIsValid: true,
      passwordIsVisible: false,
    };
  },

  provide() {
    return {
      fullName: computed(() => this.fullName), // реактивно передаем fullName
    };
  },

  methods: {
    togglePasswordVisibility() {
      this.passwordIsVisible = !this.passwordIsVisible;
    },

    async handleAuth() {
      try {
        await this.$store.dispatch("auth/handleAuth", {
          email: this.email,
          password: this.password,
          fullName: this.fullName,
          router: this.$router
        });
        this.$store.dispatch('checkLoggedIn');
      } catch (error) {
        this.errorMessage = error.message;
        if (error.code === "auth/email-already-in-use") {
          this.emailIsValid = false;
          this.passwordIsValid = false;
          this.emailErrorMessage = "This email is already in use";
        }
      }
    },
    
    async signInWithGoogle() {
      try {
        await this.$store.dispatch('auth/signInWithGoogle', this.$router)
      } catch (error) {
        this.errorMessage = error.message;
      }
    },

    switchToRegister() {
      this.$emit("switchToRegister");
    },

    handleClick() {
      if (this.passwordIsValid) {
        this.handleAuth();
      }
    },
  },
  watch: validation,
};
</script>

<style scoped>
input {
  outline: none;
  border: none;
  height: 55px;
  padding: 18px 8px;
  border-bottom: 0.823px solid rgba(0, 0, 0, 0.8);
  font-size: 2.2rem;
}
</style>